const Config = {
    baseUrl:(`${process.env.REACT_APP_SERVICE_BASE_URL}/api/1.0/`),
    launchBookUrlBase:(`${process.env.REACT_APP_SERVICE_BASE_URL}${process.env.REACT_APP_DEMO_SERVICE_URL}`),
    sampleBookService:`${process.env.REACT_APP_SERVICE_BASE_URL}${process.env.REACT_APP_LOAD_DEMO_BOOKS_URL}`,
    ddVerifyAccessCode:`${process.env.REACT_APP_SERVICE_BASE_URL}${process.env.REACT_APP_DIGITAL_DOWNLOAD_VALIDATE}`,
    ddUpdate:`${process.env.REACT_APP_SERVICE_BASE_URL}${process.env.REACT_APP_DIGITAL_DOWNLOAD_SERVICE_URL}`,
    apiKey: `${process.env.REACT_APP_API_KEY}`,
    aboutUrl:`${process.env.REACT_APP_ABOUT_URL}`,
    helpUrl:`${process.env.REACT_APP_HELP_URL}`,
    contactUrl: `${process.env.REACT_APP_CONTACT_URL}`,
    termsUrl: `${process.env.REACT_APP_TERMS_URL}`,
    privacyUrl: `${process.env.REACT_APP_PRIVACY_URL}`,
    signupUrl: `${process.env.REACT_APP_SIGNUP_URL}`,
    loginUrl: `${process.env.REACT_APP_LOGIN_URL}`
}

console.log(Config);
export default Config